(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("webrtcEngineAdapter", [], factory);
	else if(typeof exports === 'object')
		exports["webrtcEngineAdapter"] = factory();
	else
		root["webrtcEngineAdapter"] = factory();
})(window, function() {
return 